import { render, staticRenderFns } from "./AreaRow.vue?vue&type=template&id=27942b2f&"
import script from "./AreaRow.vue?vue&type=script&lang=js&"
export * from "./AreaRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports